import { useWindowSize } from 'react-use';

const useWindowDimension = () => {
  const { width } = useWindowSize();

  return { isSmallScreen: width < 768, isLargeScreen: width > 767 };
};

export default useWindowDimension;
